/**
 * Ereignis-Kanal "Feedback-Dialog oeffnen" (WP6, K07).
 *
 * Der schwebende Feedback-Knopf besitzt die beiden Dialoge. Auf der Werkbank
 * ist der Knopf ausgeblendet (er lag dort auf "Naechstes Produkt"), der Weg
 * zum Feedback fuehrt dann ueber das Kontomenue. Das Menue kennt den Knopf
 * nicht, es ruft nur `requestFeedback`; der Knopf hoert zu und oeffnet.
 * Muster: `lib/b2bConfirmGate.ts` (ein Modul, ein Host).
 */
export type FeedbackRequestKind = 'feature' | 'bug' | 'feedback' | 'praise';

type Listener = (kind: FeedbackRequestKind) => void;

const listeners = new Set<Listener>();

/** Oeffnet den passenden Dialog. false, wenn kein Knopf montiert ist (ausgeloggt). */
export function requestFeedback(kind: FeedbackRequestKind): boolean {
  if (listeners.size === 0) return false;
  for (const listener of listeners) listener(kind);
  return true;
}

export function onFeedbackRequest(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * Routen, auf denen der Knopf nicht erscheint. Die Werkbank hat ihre
 * Entscheidungsleiste unten rechts in der Karte (C2, In-Flow, nicht bei
 * `useStickyActionBar` angemeldet), der Knopf deckte dort "Naechstes Produkt"
 * ab (elementFromPoint in der Mitte von Next traf den Knopf, 1440 und 1024).
 * SYNC mit FLUID_ROUTES in `components/Layout.tsx`.
 */
export const FAB_HIDDEN_ROUTES: readonly string[] = ['/workbench', '/internal/entwurf-werkbank'];

export function isFabHiddenRoute(pathname: string): boolean {
  return FAB_HIDDEN_ROUTES.includes(pathname);
}

/**
 * Unter der Overlay-Ebene von Radix (Dialog/Sheet `z-50`) und unter dem
 * Banner-Stapel (`z-40`), damit ein offener Dialog den Knopf abdunkelt statt
 * ihn scharf darueber zu zeigen.
 */
export const FAB_LAYER_CLASS = 'z-30';
